(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('d3')) :
	(factory((global.d3 = global.d3 || {}),global.d3));
}(this, (function (exports, d3) {
    

let svg, monthFilter = null;
let dayData;
const radiusMinus = 20;
const halfPI = Math.PI / 2

let config =
{
	container : null,
	data: [],
	width: 300,
	height: 300,
	radius: 75,
	showBars: true,
	showCircle: true,
	isLarge: false,
	circleType: "month", // quart
	lang : "HU",
	type: "month",
	monthList : {
		"HU": ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
		"EN": ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	},
	circleMonth : {
		"HU": ['márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.', 'jan.', 'febr.'],
		"EN": ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec', 'Jan', 'Feb']
	},
	dayList : {
		"HU": ['H','K','SZ','CS','P', 'SZ', 'V'],
		"EN" :  ['MO','TU','WE','TH','FR', 'SA', 'SU']
	},
	accidentText: {
		"HU": "baleset",
		"EN" : "accident"
	},
	circleSeason: {
		"HU" : ["TAVASZ", "NYÁR", "ŐSZ", "TÉL"],
		"EN" : ["Spring", "Summer", "Autumn", "Winter"]
	},
	colors: {
		mainColor : "#FFBF3F",
		subColor  : "#ddd",
		selected  : "#dd9d1d"
	}
}
d3.selection.prototype.sun = function () {
	config.container = this;
	config.container.on("change", changeContainer());
	svg = d3.select('#sunContainer')
	if (svg._groups[0][0] == null)
		svg = this
			.append('svg')
				.attr('id', 'sunContainer')
				.attr('width', config.width)
				.attr('height', config.height)
				.attr('shape-rendering','crispEdges')

	renderCircle();
	renderSeasons()
	renderSunShine();
	renderDayBar()
	return svg;

}
d3.selection.prototype.size = function(size) {
	if (config.width !== size || config.height !==size) {
		config.width = size;
		config.height = size;
		if (config.radius === 0)
			config.radius = size/2
			
		svg.attr('width', config.width)
			.attr('height', config.height)
		resizeCircle()
		resizSeasons();
		update();
	}
	return svg;
}
d3.selection.prototype.radius = function(radius) {
	if (config.radius !== radius) {
		config.radius = radius;
		resizeCircle();
		resizSeasons();
		update();
	}
	return svg;
}
d3.selection.prototype.setlanguage = function(language) {
	if (config.lang !== language) {
		config.lang = language;
		//update();
		setlanguage()
	}
	return svg;
}
d3.selection.prototype.settext = function(type, language, data) {
	config[type][language] = data;
	return svg;
}
d3.selection.prototype.circleType = function(circleType) {
	config.circleType = circleType;
	return svg;
}

d3.selection.prototype.sundata = function (data) {
	config.data = data;

//	dayData = config.data.reduce((res, d) => {
	dayData = {0:[],1:[],2:[],3:[],4:[],5:[],6:[]}
	for (const d of config.data) {
		const date = new Date(d.date);
		const day = date.getDay();
		if (!dayData[day]) {
			dayData[day] = [{
				count: d.count,
				month: date.getMonth(),
				day: day
			}]
		} else {
			dayData[day].push({
				count: d.count,
				month: date.getMonth(),
				day: day
			})
		}
	}
	//	return res
	//}, {})

	update();
	return svg;
}

function NumberFormat(x){
	return x.toLocaleString('hu-HU');
  }
function update() {
		updateSunShine()
		updateDayBar();
}

function renderCircle() {
	if (d3.select(".arcContainer")._groups[0][0]!== null)
		return true;
	const data = d3.pie()
		.sort(null)
		.value(d => 1)
		(config.circleMonth[config.lang])
	const cx = config.width / 2
	const cy = config.height / 2
	if (config.radius === 0)
		config.radius = Math.min(cx, cy)
	const arc = d3.arc()
		.innerRadius(config.radius - radiusMinus)
 		.outerRadius(config.radius)
		.padAngle(0)

	const atBottom = d => {
		const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
		return middle >= 0 && middle < Math.PI
	}
	data.forEach(d => d.uid = 'p-' + d.index)

	const acrContainer = svg.append('g')
		.attr('class', 'arcContainer')
	const g = acrContainer.selectAll('g.arcLabel')
		.data(data)
		.enter()
		.append('g')
		// .attr('class', 'arcLabel')
		.attr('class', d => { return `arcLabel arcLabel-s${getSeasonByMonth(d.index)}`})
		.attr('transform', `translate(${cx}, ${cy})`)
 		.on("mouseover touchstart", function(d) {
			d3.select(this).classed("selected", true)
			hideinfo(400);
			const index = parseInt(d.index)+2;
			const key = index>11?index-12:index;
			const accidents = orderedByDay.reduce((a,b) => {
				return a+(b.month==key?parseInt(b.count):0)},0)
			d3.select("#monthLabel").text(config.monthList[config.lang][key])
			.transition()
			.duration(200)
			.style("opacity",1);
			d3.select("#accidentLabel").text(`${NumberFormat(accidents)} ${config.accidentText[config.lang]}`)
			.transition()
			.duration(200)
			.style("opacity",1);
			monthFilter = [key];
			updateDayBar()
			d3.select("#SunShines").selectAll(`.line.line-m${key}`)
				.classed("selected",true)
			d3.selectAll(`.monthLabel-m${key}`)
				.selectAll(".strokepath")
				.classed("selected", true);
				
		})
		.on("mouseleave touchend", function() {
			d3.select(this).classed("selected", false)
			d3.select("#monthLabel")
			.style("opacity",0);
			monthFilter = null;
			updateDayBar();
			d3.select("#SunShines").selectAll(".line")
			.classed("selected",false)
			d3.select("#accidentLabel").style("opacity",0);
			d3.selectAll(`.monthLabel`)
			.selectAll(".strokepath")
			.classed("selected", false);
		}) 
	g.append('path')
		.attr('id', d => d.uid)
		.attr("class", "fillPath")
		.attr('d', d => {
			const context = d3.path()
			if (atBottom(d)) {
				context.arc(0, 0, config.radius, d.endAngle - halfPI, d.startAngle - halfPI, true)
			} else {
				context.arc(0, 0, config.radius, d.startAngle - halfPI, d.endAngle - halfPI, false)
			}
			return context.toString()
		})
	g.append('path')
		.attr("class", "strokepath")
		.style('stroke-width', 1)
		.attr('d', d => arc(d))
	g.append('text')
		.style('fill', 'white')
		.style("font-size", ".8rem")
		.style('font-weight', 'normal')
		.attr('dy', d => 10 * (atBottom(d) ? -1 : 1))
		.attr('dominant-baseline', 'middle')
		.attr('text-anchor', 'middle')
		.append('textPath')
		.attr('startOffset', '50%')
		.attr('xlink:href', d => '#' + d.uid)
		.text(d => d.data)
}

function renderSeasons() {
	if (d3.select(".seasonsContainer")._groups[0][0]!== null)
		return true;
	const data = d3.pie()
		.sort(null)
		.value(d => 1)
		(config.circleSeason[config.lang])
	const cx = config.width / 2
	const cy = config.height / 2
	const seasonRadius = config.radius- 20;
	const arc = d3.arc()
		.innerRadius(seasonRadius - radiusMinus)
		.outerRadius(seasonRadius)
		.padAngle(0)

	const atBottom = d => {
		const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
		return middle >= 0 && middle < Math.PI
	}
	data.forEach(d => d.uid = 'ps-' + d.index)

	const acrContainer = svg.append('g')
		.attr('class', 'seasonsContainer')
	const g = acrContainer.selectAll('g.seasonLabel')
		.data(data)
		.enter()
		.append('g')
		// .attr('class', 'arcLabel')
		.attr('class', d => 'seasonLabel')
		.attr('transform', `translate(${cx}, ${cy})`)
		.on("mouseover touchstart", function(d) {
			d3.select(this).classed("selected", true)
			hideinfo(200);
			const index = parseInt(d.index);
			const key = index>11?index-12:index;
			d3.select("#monthLabel").text(config.circleSeason[config.lang][key])
			.style("opacity",1);


			switch(key) {
				case 0:
				  monthFilter = [2,3,4]
				  break;
				case 1:
				  monthFilter = [5, 6,7]
				  break;
				case 2:
				  monthFilter = [8,9,10]
				  break;
				case 3:
				  monthFilter = [11,0,1]
				  break;
			  } 

			const accidents = orderedByDay.reduce((a,b) => {
				return a+(monthFilter.includes(b.month)?parseInt(b.count):0)},0)
			d3.select("#accidentLabel").text(`${NumberFormat(accidents)} ${config.accidentText[config.lang]}`)
			.style("opacity",1);
			//monthFilter = [key];
			updateDayBar()
			d3.select("#SunShines").selectAll(`.line.line-s${key}`)
			.classed("selected",true)
			d3.selectAll(`.arcLabel-s${key}`)
			.classed("selected", true);
			for (const monthKey of monthFilter)
				d3.selectAll(`.monthLabel-m${monthKey}`)
				.selectAll(".strokepath")
				.classed("selected", true);
		})
		.on("mouseleave touchend", function() {
			d3.select(this).classed("selected", false)
			d3.selectAll("line.line")
			.classed("selected",false)
			d3.selectAll(".arcLabel").classed("selected", false);
			d3.select("#monthLabel")
			.style("opacity",0);
			d3.select("#accidentLabel")
			.style("opacity",0);
			d3.selectAll(`.monthLabel`)
			.selectAll(".strokepath")
			.classed("selected", false);
			monthFilter = null;
			updateDayBar();

		})
	g.append('path')
		.attr('id', d => d.uid)
		.attr("class", "fillPath")
		.attr('d', d => {
			const context = d3.path()
			if (atBottom(d)) {
				context.arc(0, 0, seasonRadius, d.endAngle - halfPI, d.startAngle - halfPI, true)
			} else {
				context.arc(0, 0, seasonRadius, d.startAngle - halfPI, d.endAngle - halfPI, false)
			}
			return context.toString()
		})
	g.append('path')
		.attr("class", "strokepath")
		.style('stroke-width', 1)
		.attr('d', d => arc(d))
	g.append('text')
		.style('fill', 'white')
		.style("font-size", ".8rem")
		.style('font-weight', 'normal')
		.attr('dy', d => 10 * (atBottom(d) ? -1 : 1))
		.attr('dominant-baseline', 'middle')
		.attr('text-anchor', 'middle')
		.append('textPath')
		.attr('startOffset', '50%')
		.attr('xlink:href', d => '#' + d.uid)
		.text(d => d.data)
}
const dayOfYear = (day)  => {
	day.setYear(2016)
	 var j1 = new Date(day)
	j1.setYear(2016)
	j1.setMonth(0, 0)
	return Math.round((day - j1) / 8.64e7) 
}
let orderedByDay

function renderSunShine() {
	if (d3.select("#SunShines")._groups[0][0] === null) {
		svg.append('g')
			.attr('id', 'SunShines')
			.attr('transform', function (d) {
				const rotateChart = -380 / 365 * 59
				return 'rotate(' + rotateChart + ',' + config.width / 2 + ',' + config.height / 2 + ')'
			})
		const sunRange = (start, end) => Array.from({length: (end - start)}, (v, k) => { return {count: 0, day: k, date: 0, month:0}} );
		orderedByDay = sunRange(1,368)
		const length = config.width * .5 * .5
		svg.select("#SunShines").selectAll()
			.data(orderedByDay)
			.enter()
			.append('line')
			.attr("class",function(d) {
				return "line";
			})
			.attr('transform', function (d) {
				const rotate = (parseInt(d.day) - 2) * (360 / 366)
				return 'rotate(' + rotate + ', ' + config.width / 2 + ', ' + config.height / 2 + ')'
			})
			.attr('x1', config.width / 2)
			.attr('y1', length)
			.attr('x2', config.width / 2)
			.attr('y2', length)
			.on('mouseover touchstart', function (d) {
				d3.select(this)
					.classed("selected", true)
				const actual = orderedByDay.find(x => x.day === d.day)
				if (typeof actual !== "undefined")
					showinfo(actual)
			})
			.on('mouseleave touchend', function (d) {
				d3.select(this)
					.classed("selected", false)
				hideinfo(2000);
			}) 

		svg
			.append("g")
			.attr("id", "infoBar")
			.attr('transform', `translate(${(config.width)/2}, ${config.height/2-config.width/55})`)
			.style("opacity",0)
			.append("circle")
				.attr("cx",0)
				.attr("cy", 0)
				.attr("r", config.radius-radiusMinus)
				.style("fill", "rgba(255, 140, 0, 0.4)")
	}
	if (d3.select(".MonthShines")._groups[0][0] === null) {
		const data = d3.pie()
		.sort(null)
		.value(d => 1)
		(config.circleMonth[config.lang])
		const cx = config.width / 2
		const cy = config.height / 2
		if (config.radius === 0)
			config.radius = Math.min(cx, cy)
		const arc =  d3.arc()
			.innerRadius((d) =>config.radius)
			.outerRadius(config.radius)
			.padAngle(0)

		const atBottom = d => {
			const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
			return middle >= 0 && middle < Math.PI
		}
		const colors = ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce','#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a','#8bbc21','#8bbc21',]
		data.forEach(d => d.uid = 'p-' + d.index)

		const acrContainer = svg.append('g')
			.attr('class', 'MonthShines')
			.attr('transform', function (d) {
				const rotateChart = -380 / 365 * 59
				return 'rotate(' + rotateChart + ',' + config.width / 2 + ',' + config.height / 2 + ')'
			})
		const g = acrContainer.selectAll('g.arcLabel')
			//.attr('class', 'monthLabel')
			.data(data)
			.enter()
			.append('g')
			// .attr('class', 'arcLabel')
			.attr('class', d => { return `monthLabel monthLabel-m${d.index} monthLabel-s${getSeasonByMonth(d.index)}`})
			.attr('transform', `translate(${cx}, ${cy})`)
		g.append('path')
			.attr('id', d => d.uid)
			.attr("class", "fillPath")
			.attr('d', d => {
				const context = d3.path()
				if (atBottom(d)) {
					context.arc(0, 0, config.radius, d.endAngle - halfPI, d.startAngle - halfPI, true)
				} else {
					context.arc(0, 0, config.radius, d.startAngle - halfPI, d.endAngle - halfPI, false)
				}
				return context.toString()
			})
		g.append('path')
			.attr("class", "strokepath")
			.style('stroke-width', 1)
			.attr('d', d => arc(d))
		}
}

function updateSunShine() {
	orderedByDay = []
	if (config.data.length>0) {
		config.data.forEach(d => {
			const actualDate = new Date(d.date)
			const actualDay = dayOfYear(actualDate)
			if (!orderedByDay[actualDay]) {
				orderedByDay[actualDay] = {
					count: d.count,
					day: actualDay,
					date: actualDate.getDate(),
					month: actualDate.getMonth()
				}
			} else
				orderedByDay[actualDay].count += d.count
		})
	orderedByDay = Object.values(orderedByDay)
}
	const sunCount = orderedByDay.length;
	const maxY = d3.max(orderedByDay, function (d) {
		return d.count
	}) 
	const length = config.width * .5 * .5
	const sunShine = svg.selectAll("#SunShines")

	const MonthShine = svg.selectAll(".MonthShines");
	if (config.circleType == "day") {
		sunShine.selectAll("line").style("display", "block");
		sunShine.selectAll("line").style("opacity", 1);
		d3.selectAll("#daysBar").style("display", "block")
		sunShine.style("opacity", 1);
		MonthShine.style("opacity", 0);
		sunShine
			.attr('transform', function (d) {
				const rotateChart = -380 / 369 * 58
				return 'rotate(' + rotateChart + ',' + config.width / 2 + ',' + config.height / 2 + ')'
			})

		sunShine
		.selectAll("line")
			.style("stroke-width", function() { return config.height > window.innerHeight/2 || config.width > window.innerWidth/2? 3: 1})
			.attr('transform', function (d) {
				const rotate = (parseInt(d.day)) * (360 / 366)
				return 'rotate(' + rotate + ', ' + config.width / 2 + ', ' + config.height / 2 + ')'
			})
			.attr('x1', config.width / 2)
			.attr('y1', length)
			.attr('x2', config.width / 2)
			.transition()
			.duration(1000)
			.attr('y2', function (d) {
				const actual = orderedByDay.find(x => x.day === d.day)
				if (typeof actual !== "undefined")
					return length - (actual.count * length / maxY)
				return length
			})
			.attr("class", function(d) {
				const actual = orderedByDay.find(x => x.day === d.day);
				if (typeof actual !== "undefined")
					return "line line-m"+actual.month+" line-s"+getSeasonByMonth(actual.month-2);

				return "line";
			})
	}
	else {
		sunShine.selectAll("line").style("display", "none");
		d3.selectAll("#daysBar").style("display", "none")
		MonthShine.style("opacity", 1);

		const height = d3.scaleLinear()
		.range([0, Math.min(config.width / 4, 70)]);
		height.domain([0, d3.max(orderedByDay, function (d) {
			return d.count;
		})]);
		if (orderedByDay.length > 0 && config.data.length>0) {
			d3.selectAll('.MonthShines').style("opacity",1);
			orderedByDay.push(orderedByDay.shift())
			orderedByDay.push(orderedByDay.shift())
			orderedByDay.push(orderedByDay.shift())
			const cx = config.width / 2
			const cy = config.height / 2
			if (config.radius === 0)
				config.radius = Math.min(cx, cy)

				
			const arc =  d3.arc()
				.innerRadius((d) => { 
					const item = orderedByDay.find(x =>  x.month == d.index)
					return config.radius + height((item != undefined)?item.count:0)
				})
				.outerRadius(config.radius)
				.padAngle(0.02)

			

			const atBottom = d => {
				const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
				return middle >= 0 && middle < Math.PI
			}

			d3.selectAll('.monthLabel').style("oapcity",1);
			orderedByDay.forEach(d => d.uid = 'mp-' + d.month)
			const acrContainer = svg.select('.MonthShine')
			const g = acrContainer
				.data(orderedByDay)
				.enter()

	/* 			.selectAll('.monthLabel .strokepath')

				.attr('d', d => arc(d)) */

			g.selectAll('.monthLabel  .fillPath')
				.attr('d', d => {
					const context = d3.path()
					if (atBottom(d)) {
						context.arc(0, 0, config.radius, d.endAngle - halfPI, d.startAngle - halfPI, true)
					} else {
						context.arc(0, 0, config.radius, d.startAngle - halfPI, d.endAngle - halfPI, false)
					}
					return context.toString()
				})
			g.selectAll('.monthLabel .strokepath')
				.attr('d', d => arc(d))


				
			d3.selectAll('.MonthShines')
			.attr('transform', function (d) {
				const rotateChart = -380 / 365 * 59
				return 'translate(0,0) rotate(' + rotateChart + ',' + config.width / 2 + ',' + config.height / 2 + ')'
			})
			d3.selectAll('.monthLabel ').attr('transform', `translate(${cx}, ${cy})`)
			acrContainer.selectAll('.monthLabel').attr("class", d => { return  `monthLabel monthLabel-${d.uid}`})
		}
		else {
			d3.selectAll('.MonthShines').style("opacity",0);
		}

	}

	

		d3.select("#infoBar")
			.attr('transform', `translate(${(config.width)/2}, ${config.height/2-config.width/55})`)

			
}
function renderDayBar() {
	if (d3.select("#daysBar")._groups[0][0]!== null)
	return true;
	const barWidth = config.width / 2 - config.radius;
	const barHeight = (config.height / 2 - config.radius) / 2;
	const cx = (config.width - barWidth) / 2
	const cy = (config.width - barHeight) / 2

/*  	const usedData = Object.values(dayData).map(x => {
		let counter = 0;
		x.forEach(x => counter += x.count)
		return counter;
	})
	if (usedData.length > 1) usedData.push(usedData.shift())  */
	const usedData = [0,0,0,0,0,0,0]

	const daysBar = svg.append('g')
		.attr('id', 'daysBar')
		.attr('transform', `translate(${cx}, ${cy})`)


 	let x = d3.scaleBand()
		.range([0, barWidth])
		.padding(0.3);
	let y = d3.scaleLinear()
		.range([barHeight, 0]);

	x.domain([0,0]);
	y.domain([0, d3.max(usedData, function (d) {
		return d;
	})]); 

	 daysBar.selectAll(".bar")
		.data(usedData)
		.enter()
		.append("g")
		.classed("barcontainer", true) 
		.append("rect")
		.attr("class", "dayBar")

  	d3.selectAll(".barcontainer")
		.append("text")
		.style("text-anchor", "middle")
		.attr("class","label")
		.attr("x", function(d,i) {  return isNaN(x(i)+x.bandwidth()/2)?0:x(i)+x.bandwidth()/2 })
		.attr("y", function(d) { return barHeight-2 })
		//.attr("dy", ".75em")
		.style("font-weight", "bold")
		.style("font-size", "0.4rem")
		.style("font-size", config.width/1000+"rem")
		.text(function(d,i) { return config.dayList[config.lang][i]});  

	daysBar.append("text")
		.attr("id", "monthLabel")
		.style("opacity",0)
		.attr("text-anchor","middle")
		.attr("dominant-baseline","hanging")
		.text("")
		.style("font-size", config.width/500+"rem")
		.attr('transform', `translate(${barHeight}, ${barHeight})`)
	daysBar.append("text")
		.attr("id", "accidentLabel")
		.style("opacity",0)
		.attr("text-anchor","middle")
		.attr("dominant-baseline","hanging")
		.text("")
		.style("font-size", config.width/500+"rem")
		.attr('transform', `translate(${barHeight}, ${barHeight})`)
 
}
function updateDayBar() {
	if (config.circleType!=="day") {
		d3.selectAll("#daysBar").style("display","none");
		d3.selectAll("#infoBar").style("display","none");
		return;
	}
	d3.selectAll("#daysBar").style("display","block");
	d3.selectAll("#infoBar").style("display","block");

	const barWidth = Math.max(0, config.width / 2 - config.radius -20);
	const barHeight = Math.max(0, (config.height / 2 - config.radius) / 2 -20);
	const cx = (config.width - barWidth) / 2
	const cy = (config.width - barHeight) / 2

	let usedData = [0,0,0,0,0,0,0];
	if (dayData)
	usedData = Object.values(dayData).map(x => {
		let counter = 0;
		x.forEach(x =>  {
			if (monthFilter !== null){
				if (monthFilter.includes(x.month))
					counter += x.count
			}
			else
				counter += x.count
		})
		return counter;
	})
	if (usedData.length > 1) usedData.push(usedData.shift())
	if (usedData.length < 1) usedData = [0,0,0,0,0,0,0]
	let x = d3.scaleBand()
		.range([0, barWidth])
		.padding(0.3);
	let y = d3.scaleLinear()
		.range([barHeight, 0]);
	x.domain((dayData && Object.keys(dayData).length>0)?Object.keys(dayData): [0,0]);
	y.domain([0, d3.max(usedData, function (d) {
		return d;
	})]);

	svg.selectAll(".barcontainer text")
	.attr("x", function(d,i) {  return isNaN(x(i)+x.bandwidth()/2)?0:x(i)+x.bandwidth()/2 })
	.attr("y", function(d) { return barHeight-2 })
	.style("font-size", config.width/1200+"rem")

	d3.select("#infoBar").style("opacity",0);
	const dayBar = svg.select('#daysBar')
		.attr('transform', `translate(${cx}, ${cy})`)
		.style("opacity",1);

	dayBar.selectAll(".bar")
		.data(usedData)
		.enter()
		.selectAll(".dayBar")

		.attr("x", function (d, k) {
			return x(k);
		})
		.attr("width", x.bandwidth())
		.on("mouseover touchstart", function(d,k) {
			d3.select(this).classed("selected", true)
			d3.select("#accidentLabel").text(`${NumberFormat(usedData[k])} ${config.accidentText[config.lang]}`).style("opacity",1);
		})
		.on("mouseleave touchend", function() {
			d3.select(this).classed("selected", false)
			d3.select("#accidentLabel").text("").style("opacity",0);
		})
		.transition()
		.duration(500)
		.attr("y", function (d,k) {
			return y(usedData[k]);
		})

		.attr("height", function (d,k) {
			return (usedData[k]==0)? 0 : barHeight - y(usedData[k]);
		})

	dayBar.select("#monthLabel")
		.style("font-size", config.width/500+"rem")
		.attr('transform', `translate(${barWidth/2}, ${-barHeight/1.5})`)

	dayBar.select("#accidentLabel")
		.style("font-size", config.width/500+"rem")
		.attr('transform', `translate(${barWidth/2}, ${barHeight+barHeight/4})`)
}
function showinfo(data) {
	const infoBar = d3.select("#infoBar");
	const fontSize = +Math.floor( ((config.width<301)?config.width/20:config.width) /500)+".65rem"
	infoBar.html("");
	infoBar
		.style("font-size", fontSize)
		.transition()
		.duration(5)
		.style("opacity",1)
	const text = infoBar
		.append("text")
		.attr("fill", "white")
		.style("text-anchor", "middle")

	text
		.append("tspan")
		.text(config.monthList[config.lang][data.month]+" "+data.date)
		.attr("x", 0)
		.attr("dx", 0)
		.attr("dy", 0);
	text
		.append("tspan")
		.text(`${NumberFormat(data.count)} ${config.accidentText[config.lang]}`)
		.attr("x", 0)
		.attr("dx", 0)
		.attr("dy", function (d) { return config.height/15});

	d3.select("#daysBar") 
		.transition()
		.duration(5)
		.style("opacity",0)
}
function hideinfo(duration) {
	d3.select("#infoBar")
		.transition()
		.duration(duration)
		.style("opacity",0)
	d3.select("#daysBar") 
		.transition()
		.duration(duration)
		.style("opacity",1)
}
function changeContainer() {
	if (config.container._groups[0][0]!== null) {
		if (config.container.classed("large"))
			d3.selectAll(".barcontainer text")
				.style("font-size", "0.8rem")
		else
			d3.selectAll(".barcontainer text")
				.style("font-size", "0.4rem")
	}
}
function resizeCircle() {
	const cx = config.width /2
	const cy = config.height / 2
	const arc = d3.arc()
		.innerRadius(config.radius - radiusMinus)
		.outerRadius(config.radius)
		//.padAngle(Math.PI / 180)
		.padAngle(0);

	const atBottom = d => {
		const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
		return middle >= 0 && middle < Math.PI
	}
 	d3.selectAll(".arcContainer .arcLabel")
		.transition()
		.duration(200)
		.attr('transform', `translate(${cx}, ${cy})`)
		.selectAll(".fillPath")
			.attr('d', d => {
				const context = d3.path()
				if (atBottom(d)) {
					context.arc(0, 0, config.radius, d.endAngle - halfPI, d.startAngle - halfPI, true)
				} else {
					context.arc(0, 0, config.radius, d.startAngle - halfPI, d.endAngle - halfPI, false)
				}
				return context.toString()
			})
	d3.selectAll(".arcContainer .arcLabel .strokepath")
		.transition()
		.duration(200)
		.attr('d', d => arc(d))
}
function resizSeasons() {
	const cx = config.width /2
	const cy = config.height / 2
	const seasonRadius = config.radius-20;
	const arc = d3.arc()
		.innerRadius(seasonRadius - radiusMinus)
		.outerRadius(seasonRadius)
		.padAngle(0)

	const atBottom = d => {
		const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2
		return middle >= 0 && middle < Math.PI
	}
 	d3.selectAll(".seasonsContainer .seasonLabel")
		.transition()
		.duration(200)
		.attr('transform', `translate(${cx}, ${cy})`)
		.selectAll(".fillPath")
			.attr('d', d => {
				const context = d3.path()
				if (atBottom(d)) {
					context.arc(0, 0, seasonRadius, d.endAngle - halfPI, d.startAngle - halfPI, true)
				} else {
					context.arc(0, 0, seasonRadius, d.startAngle - halfPI, d.endAngle - halfPI, false)
				}
				return context.toString()
			})
	d3.selectAll(".seasonsContainer .seasonLabel .strokepath")
		.transition()
		.duration(200)
		.attr('d', d => arc(d))
}
function setlanguage() {
	d3.selectAll(".barcontainer text").text(function(d,i) { return config.dayList[config.lang][i]});  
	d3.select(".arcContainer").remove();
	renderCircle();
	//d3.selectAll(".arcLabel text").text("asd");
}

const getSeasonByMonth = (month) => {
	if (month<0)
		return 3

	if (month<3)
		return 0
	if (month<6)
		return 1
	if (month<9)
		return 2
	
	return 3
	
}
/* function test() {

} */


Object.defineProperty(exports, '__esModule', {
	value: true
});

})));